export default __webpack_public_path__ + "static/media/adyen.332ad62b.svg";